import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/firebase';
import WIcon from './shared/WIcon';
import logo from '../assets/logo_white.png';

const NAV_ITEMS = [
  { id: 'dashboard',     to: '/admin',              icon: 'overview',  label: 'Overview' },
  { id: 'applications',  to: '/admin/applications', icon: 'briefcase', label: 'Applications' },
  { id: 'companies',     to: '/admin/companies',    icon: 'building',  label: 'Companies' },
  { id: 'vendors',       to: '/admin/vendors',      icon: 'store',     label: 'Vendors' },
  { id: 'employees',     to: '/admin/employees',    icon: 'users',     label: 'All Users' },
  { id: 'mock-data',     to: '/admin/mock-data',    icon: 'layers',    label: 'Mock Data' },
  { id: 'settings',      to: '/admin/settings',     icon: 'settings',  label: 'Settings' },
];

const Sidebar = ({ adminEmail }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error('Sign out failed:', err);
    }
    localStorage.removeItem('superAdminAuth');
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  const initials = (adminEmail || 'SA').split('@')[0].slice(0, 2).toUpperCase();
  const displayName = adminEmail || 'Super Admin';

  return (
    <aside className="loysta-sidebar">
      <div className="loysta-sidebar-header">
        <img src={logo} alt="Loysta" />
      </div>

      <div className="loysta-sidebar-portal-label">
        <span className="dot" />
        Super Admin
      </div>

      <nav className="loysta-sidebar-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.id}
            to={item.to}
            end={item.to === '/admin'}
            className={({ isActive }) => `loysta-nav-link${isActive ? ' active' : ''}`}
          >
            <WIcon name={item.icon} size={17} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="loysta-sidebar-footer">
        <div className="loysta-sidebar-user">
          <div className="loysta-sidebar-user-avatar">{initials}</div>
          <div className="loysta-sidebar-user-info">
            <div className="loysta-sidebar-user-name">{displayName}</div>
            <div className="loysta-sidebar-user-sub">Super Admin</div>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="loysta-sidebar-logout-btn"
            title="Sign out"
          >
            <WIcon name="logout" size={15} />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
